import { Component, OnInit, viewChild, inject } from '@angular/core';
import { FormsModule, NgModel } from '@angular/forms';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { RequestBuilderService } from '../../../../../shared/services/request-builder.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-delete-dialog',
  standalone: true,
  imports: [FormsModule, ButtonComponent, AutoCompleteModule],
  templateUrl: './delete-dialog.component.html',
  styleUrl: './delete-dialog.component.scss',
})
export class DeleteDialogComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly requestBuilder = inject(RequestBuilderService);
  private readonly messageService = inject(MessageService);

  readonly reasonInput = viewChild.required<NgModel | undefined>('reasonInput');
  loading = false;
  reason: string = '';
  suggestions: string[] = [`Driver accepted ride offer by mistake.`, `Driver declined ride offer by mistake.`];
  filteredSuggestions: string[] = [];

  ngOnInit() {
    this.filteredSuggestions = [...this.suggestions];
  }

  confirmAction() {
    if (this.reasonInput()?.invalid) return;

    this.loading = true;

    if (this.config.data.action == 'resetRide') {
      const body = {
        internalNote: this.reason,
      };
      this.requestBuilder.patch(`rides/${this.config.data.uuid}/reset`, body).subscribe({
        next: () => {
          this.loading = false;

          this.ref.close({ confirmed: true, resetRide: true });
        },
        error: err => {
          console.log(err);

          this.loading = false;
          this.messageService.add({
            severity: 'danger',
            summary: 'Something Went wrong!',
            detail: err?.error?.message ?? '',
            life: 6000,
          });
        },
      });
    }

    if (this.config.data.action == 'deleteRide') {
      const body = {
        internalNote: this.reason,
      };
      this.requestBuilder.patch(`rides/${this.config.data.uuid}/delete`, body).subscribe({
        next: () => {
          this.loading = false;
          this.ref.close({ confirmed: true });
        },
        error: err => {
          this.loading = false;
        },
      });
    }
  }

  filterSuggestions(event: any, autoComplete: AutoComplete) {
    if (this.reason) {
      this.filteredSuggestions = this.suggestions.filter(suggestion => suggestion.toLowerCase().includes(this.reason.toLowerCase()));
    } else {
      this.filteredSuggestions = [...this.suggestions];
      if (this.filteredSuggestions.length > 0) {
        autoComplete.show();
      }
    }
  }
}
